export const patientSearch = {
  patientSearchErrorCode: "No Patient found with this code and birth date",
  patientSearchErrorMrn: "No Patient found with this MRN and birth date",
  patientSearchFail: "Patient search failed"
};
